var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex-grow-1"},[(_vm.errorGettingData)?_c('Alert',{attrs:{"variant":"danger"}},[_vm._v(" "+_vm._s(_vm.$t('R._MES_ProblemRetrievingReports'))+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }